// disable auto-story

import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import BladeLevel from './blade-level';
import useBladeItemPositioning from './use-blade-item-positioning';

interface BladeItemProps {
  text: string;
  children?: { [key: string]: BladeItemProps };
  href: string;
  divider: boolean;
  isOpen: boolean;
  onOpen: () => void;
  level?: number;
}

/**
 * Represents one item within a Blade dropdown menu.
 */
function BladeItem({ text, href, children, onOpen, isOpen, divider, level = 0 }: BladeItemProps) {
  const { top, itemRef } = useBladeItemPositioning();

  if (divider) {
    return <li className="border-t-[1px] my-2" />;
  } else if (children) {
    const classes = classNames('py-2 text-sm cursor-pointer hover:text-link text-left', {
      'text-link': isOpen,
    });

    return (
      <li>
        <button
          className={twMerge('block w-full right-arrow', classes)}
          dangerouslySetInnerHTML={{ __html: text }}
          onClick={onOpen}
          ref={itemRef}
        />
        <div
          className={twMerge(
            'absolute left-full ml-[2px] transition-all scale-y-100 opacity-100 origin-top',
            !isOpen && 'invisible scale-y-50 opacity-0'
          )}
          style={{ top }}
        >
          <BladeLevel level={level}>{children}</BladeLevel>
        </div>
      </li>
    );
  } else {
    return (
      <li>
        <a className="blade-item" dangerouslySetInnerHTML={{ __html: text }} href={href} />
      </li>
    );
  }
}

export default BladeItem;
